export default __webpack_public_path__ + "static/media/080_finish_bad.93f18d7b.mp4";